<template>
  <div class="content">
    <template >
      <div class="table-page-search-wrapper search-bt">
        <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item label="版本">
                <global-select
                  @change="handleVersionChange"
                  :value.sync="queryParams.versionCode"
                  selectType="select"
                  :setParams="{ id: this.queryParams.id }"
                  requestApi="/scp/scpMpsBasicData/versionList"
                  :selectItem="{ value: 'selectedValue', label: 'label' }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="说明">
                <a-input :disabled="true" v-model="queryParams.description"></a-input>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="工艺大类">
                  <global-select
                    :max-tag-count="2"
                    :max-tag-text-length="4"
                    show-search
                    :value.sync="queryParams.scpProductBroadCategory"
                    selectType="selectFilter"
                    :selectData="scpProductBroadCategoryList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="物料编码">
                  <global-select
                    :assembleLabel="false"
                    :value.sync="queryParams.itemId"
                    selectType="selectSearch"
                    requestApi="/mes/mesDiscreteJobs/assemblyBox"
                    :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                    searchParam="itemCode" />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
                <a-button @click="resetQuery" class="ml8">重置</a-button>
                <a @click="toggleAdvanced" class="ml8">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </template>
    <template>
      <a-tabs class="content-tabs" type="card" @change="callback">
        <a-tab-pane key="1" tab="日销售/发货比例">
          <daily-sales-shipment-ratio-table ref="DailySalesShipmentRatioTable" :id="queryParams.versionCode">
          </daily-sales-shipment-ratio-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="订单满足率">
          <order-fulfillment-rate-table ref="OrderFulfillmentRateTable" :id="queryParams.versionCode">
          </order-fulfillment-rate-table>
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>
  <script>
    import DailySalesShipmentRatioTable from './components/DailySalesShipmentRatioTable'
    import OrderFulfillmentRateTable from './components/OrderFulfillmentRateTable'

  export default {
    // eslint-disable-next-line
    name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {
        DailySalesShipmentRatioTable,
        OrderFulfillmentRateTable
    },
    data () {
      return {
        timer: null,
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          id: undefined,
          mpsBasicDataId: undefined,
          scpProductBroadCategory: undefined,
          itemId: undefined,
          description: undefined,
          versionCode: undefined
        },
        scpProductBroadCategoryList: [] // 工艺大类
      }
    },
    methods: {
      onSearch () {
       if (this.$refs.DailySalesShipmentRatioTable) {
        this.$refs.DailySalesShipmentRatioTable.onSearch(this.queryParams.versionCode)
       }
       if (this.$refs.OrderFulfillmentRateTable) {
        this.$refs.OrderFulfillmentRateTable.onSearch(this.queryParams.scpProductBroadCategory, this.queryParams.itemId, this.queryParams.versionCode)
       }
      },
      getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
      },
      handleVersionChange (val, list) {
        if (val) {
          const filteredObject = list.filter(obj => obj.selectedValue === val);
          this.queryParams.versionCode = filteredObject[0].selectedValue
          this.queryParams.description = filteredObject[0].realValue
        }
      },
      callback (key) {
        if (key === '1') {
          this.advanced = false;
        } else {
          this.advanced = true;
        }
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.isSetTitle = false
        this.queryParams = {
          id: this.queryParams.id,
          versionCode: this.versionCode,
          description: this.description,
          scpProductBroadCategory: undefined,
          itemId: undefined,
          unitOfMeasureList: undefined,
          forecastName: undefined,
           // 版本
          startMonth: '',
          versionDescription: '',
          supplyType: '',
          orderType: '',
          scpSinvClassify: ''
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    },
      created () {
          this.queryParams.id = this.$route.query.id; // 从路由参数中获取 id 值
         // this.queryParams.versionCode = this.$route.query.version; // 从路由参数中获取 id 值
          this.queryParams.description = this.$route.query.description; // 从路由参数中获取 id 值
          this.queryParams.versionCode = this.$route.query.id; // 从路由参数中获取 id 值
          this.versionCode = this.queryParams.versionCode;
          this.description = this.queryParams.description;
          this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'scpProductBroadCategoryList');
      },
      mounted () {
       // this.onSearch()
      }
  }
  </script>
  <style lang="less" scoped>
  .content{
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
  }.search-bt{
      background-color: white;
      padding: 8px;
      margin-bottom: 8px;
  }.content-tabs{
      background-color: white;
      width: 100%;
      flex:1;
      padding: 8px;
  }.ml8{
    margin-left: 8px
  }
  </style>
